module.exports = __webpack_public_path__ + "static/tick-questing-d97bbdfa338c42d4f446adafbb49b1df.png";